
/*const baseUrl = process.env.NODE_ENV === 'production' 
? "api-ergoapp.marianodrets.a2hosted.com" 
: "http://localhost:3001" */

const baseUrl = "https://api-adaclub.marianodrets.a2hosted.com" ;
//const baseUrl = "http://localhost:3001" ;

export const URL_DBQUERY=baseUrl;
export const URL_DB=`${baseUrl}/spget/`;
export const URL_TOKEN=`${baseUrl}/spgettokken`;
export const USR_LOG="2";
export const NOMBRE_SIST="AdaClub";
export const NOMBRE_INSTITUCION="Club all Boys Saavedra";

export const DIASEM=['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'];
export const ACCESOS=[];
